var m = require('mithril');
var loaders = require('../../layout/components/loaders');
var Model = require('../../libs/Model');
var formGroup = require('../../components/formGroup');

var pollGroup = Object.create(Model)
pollGroup.name = 'Modbus Poll Group';
pollGroup['@class'] = 'PollGroup';
pollGroup.url = 'modbuspollgroup';

pollGroup.initForm = function (record) {
  pollGroup.types = m.request({
    url: '/api/v1/modbustypes',
    method: 'GET',
  });
  Model.initForm.call(pollGroup, record);
};

pollGroup.fields = {
  parent: {
    default: null,
    hidden: true,
    validators: {
      presence: false
    }
  },
  name: {
    default: null,
    validators: {
      presence : true, 
      length: {
        minimum: 3, 
        maximum: 32, 
        default: ''
      }
    }
  },
  unitId: {
    default: 0,
    validators: {
      presence: true,
      numericality: {
        onlyInteger: true,
        greaterThanOrEqualTo: 0,
        lessThanOrEqualTo: 255
      }
    }
  },
  address: {
    default: 0,
    validators: {
      presence: true,
    },
    numericality: {
      onlyInteger: true,
      greaterThanOrEqualTo: 0,
      lessThanOrEqualTo: 65535
    }
  },
  length: {
    default: 1,
    validators: {
      presence: true,
      numericality: {
        onlyInteger: true,
        greaterThanOrEqualTo: 0,
        lessThanOrEqualTo: 65535
      }
    }
  },
  functionCode: {
    default: 3,
    validators: {
      presence: true,
      numericality: {
        onlyInteger: true,
        greaterThanOrEqualTo: 0,
        lessThanOrEqualTo: 64
      }
    }
  },
  interval : {
    default: 600,
    numericality: {
      onlyInteger: true,
      greaterThanOrEqualTo: 0
    }
  }
};

pollGroup.view = function () {
  return  m('form', {role:'form'}, [
    pollGroup.errorView(),
    m(formGroup, [
      m('label', {for:'name-input'}, 'Name'),
      m('input.form-control', {
        id:'name-input', 
        type:'text', 
        oninput: function (ev){pollGroup.form.name(ev.target.value)},
        value: pollGroup.form.name(),
      })
    ]),
    m(formGroup, [
      m('label', {for:'address-input'}, 'Unit'),
      m('input.form-control', {
        id:'unit-input', 
        autocomplete: 'off',
        type:'number', 
        oninput: function (ev){pollGroup.form.unitId(ev.target.value)},
        value: pollGroup.form.unitId(),
      })
    ]),
    m(formGroup, [
      m('label', {for:'address-input'}, 'Start'),
      m('input.form-control', {
        id:'address-input', 
        autocomplete: 'off',
        type:'number', 
        oninput: function (ev){pollGroup.form.address(ev.target.value)},
        value: pollGroup.form.address(),
      })
    ]),
    m(formGroup, [
      m('label', {for:'length-input'}, 'Length'),
      m('input.form-control', {
        id:'length-input', 
        autocomplete: 'off',
        type:'number', 
        oninput: function (ev){pollGroup.form.length(ev.target.value)},
        value: pollGroup.form.length(),
      })
    ]),
    m(formGroup, [
      m('label', {for:'function-code-input'}, 'Function Code:'),
      m('select.form-control', 
        {
          id:"function-code-input", 
          onchange: function (ev){pollGroup.form.functionCode(ev.target.value)},
          value: pollGroup.form.functionCode()
        }, 
        [
          m('option', {value: 3}, 'Read Holding Registers')
        ]
      )
    ]),
    m(formGroup, [
      m('label', {for:'type-input'}, 'Polling Interval (Seconds)'),
       m('input.form-control', {
        id:'length-input', 
        autocomplete: 'off',
        type:'number', 
        oninput: function (ev){pollGroup.form.interval(ev.target.value)},
        value: pollGroup.form.interval(),
      })
    ])

  ])  
}

module.exports = pollGroup;
